import { formatMetricValue } from "../utils/reportUtils";

const ReportMetricCard = ({ metricKey, label, value }) => (
    <article className="report-metric-card">
        <p>{label}</p>
        <strong>{formatMetricValue(metricKey, value)}</strong>
    </article>
);

export default ReportMetricCard;
